module.exports = __webpack_public_path__ + "static/img/fullscreen-image_subscribe.78e1af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/fullscreen-image_subscribe.png
// module id = dSQ/
// module chunks = 0